import { apiFetch } from "../utils/apiFetch";
export interface PartnerVertragDaten {
  beginn: string | null;
  ende: string | null;
  status: string;
  sparten: string[];
  spartenSonstiges: string;
  sort: number;
}
export interface PartnerVertrag extends PartnerVertragDaten {
  id: number;
}
const path = (contactId: number) => `contact/${contactId}/partner-vertraege`;
const write = async (url: string, method: string, data?: PartnerVertragDaten) =>
  (
    await apiFetch<PartnerVertrag>(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: data ? JSON.stringify(data) : undefined,
    })
  ).data;
export const partnerVertragService = {
  list: async (contactId: number, signal?: AbortSignal) =>
    (await apiFetch<PartnerVertrag[]>(path(contactId), { signal })).data,
  create: (contactId: number, data: PartnerVertragDaten) =>
    write(path(contactId), "POST", data),
  update: (contactId: number, id: number, data: PartnerVertragDaten) =>
    write(`${path(contactId)}/${id}`, "PUT", data),
  remove: (contactId: number, id: number) =>
    write(`${path(contactId)}/${id}`, "DELETE"),
};
